import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import {
  Box,
  ButtonProps,
  Menu,
  MenuItem,
  Button as MuiButton,
} from "@mui/material";
import { useRouter } from "next/router";
import { MouseEvent, useState } from "react";

import { theme } from "../../mui-customs/Theme";
import Typography from "../Typography";

interface TopBarNavButtonProps extends ButtonProps {
  label: string;
  handleNonExpandableClick?: () => void;
  expandable?: boolean;
  menuItems?: { label: string; link: string }[];
}

const TopBarNavButton = ({
  label,
  expandable = false,
  menuItems,
  handleNonExpandableClick,
}: TopBarNavButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const router = useRouter();
  const handleMenuItemClick = (link: string) => {
    router.push(link);
    setIsOpen(false);
  };
  const handleMenuButtonClick = (event: MouseEvent<HTMLElement>) => {
    if (expandable) {
      setAnchorEl(event.currentTarget);
      setIsOpen(true);
    } else {
      handleNonExpandableClick && handleNonExpandableClick();
    }
  };

  return (
    <Box>
      <MuiButton
        sx={{
          textTransform: "none",
          color: theme.brand1[500],
          "& :hover": {
            color: theme.brand2[500],
          },
        }}
        onClick={(event) => handleMenuButtonClick(event)}
        id={label}
        aria-controls={isOpen ? `${label}-menu` : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? "true" : undefined}
      >
        <Typography
          variant="title1"
          sx={{
            fontFamily: "Montserrat !important",
            fontSize: "16px !important",
            fontWeight: "300 !important",
          }}
        >
          {label.toLowerCase()}
        </Typography>
        {expandable && <ExpandMoreRoundedIcon />}
      </MuiButton>
      <Menu
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => setIsOpen(false)}
        id={`${label}-menu`}
        MenuListProps={{
          "aria-labelledby": label,
        }}
        sx={{
          "& .MuiList-root": {
            p: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
          },
        }}
      >
        {menuItems?.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => handleMenuItemClick(item.link)}
            sx={{
              color: theme.brand1[500],
              fontSize: 14,
              width: "200px",
              "& :hover": {
                color: theme.brand2[500],
              },
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default TopBarNavButton;
